import { Outlet } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { AuthProvider } from "react-oidc-context";
import { QueryClientProvider } from "react-query";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { useConfigContext } from "@imminently/react/context/config";
import { QueryProvider } from "@imminently/react/store/query";
import { ModalProvider, ModalRenderer } from "@imminently/react/context/modals";
import './i18n';
import { I18nProvider } from "./providers/I18nProvider";

import { store, notificationSelector } from "@/store";
import global from "@/global";
import { AppThemeProvider } from "@/theme";
import { ScrollableStyleJSX } from "@/components/scrollable";
import { AppSnackbar } from "@/components/AppNotifications";
import { AuthEvents } from "@/components/AuthEvents";
import { useAzureAuthConfig } from "@/AzureProvider";
import { SettingsProvider } from "./pages/settings/SettingsProvider";
import { TypesProvider } from "./providers/TypesProvider";
import { ConciergeModeProvider } from "./contexts/ConciergeModeContext";
import { ActAsProvider } from "./contexts/ActAsContext";

export const App = () => {
  const config = useConfigContext();
  console.log("cfg", config);

  const authConfig = useAzureAuthConfig();

  return (
    <QueryClientProvider client={global.queryClient}>
      <QueryProvider client={global.client} dataProvider={global.dataProvider}>
        <ReduxProvider store={store}>
          <AuthProvider {...authConfig}>
            <SettingsProvider>
              <I18nProvider>
                <TypesProvider>
                  <ConciergeModeProvider>
                    <ActAsProvider>
                      <ModalProvider>
                        <AppThemeProvider>
                          <LocalizationProvider dateAdapter={AdapterMoment}>
                            <CssBaseline />
                            {ScrollableStyleJSX}
                            <AuthEvents />
                            <ModalRenderer />
                            <AppSnackbar selector={notificationSelector} />
                            <Outlet />
                          </LocalizationProvider>
                        </AppThemeProvider>
                      </ModalProvider>
                    </ActAsProvider>
                  </ConciergeModeProvider>
                </TypesProvider>
              </I18nProvider>
            </SettingsProvider>
          </AuthProvider>
        </ReduxProvider>
      </QueryProvider>
    </QueryClientProvider>
  );
};

export default App;
